// extracted by mini-css-extract-plugin
export default {"select":"SelectCustom_select__Cs6J0"};